import '../css/dashboard.css';
import 'bootstrap/dist/css/bootstrap.css';
import React, { useEffect, useState, useContext, useRef, useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Button, Stack, Alert, Spinner, Form, InputGroup } from 'react-bootstrap';
import LoggedInContainer from '../layout/LoggedInContainer';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretLeft, faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import {
    getDetailedConsignmentDeparturePort, getConsignmenLivestockLoadedForDeparturePort, getGroupedConsignmenPlannedLivestock,
    getDeparturePorts, getDestinationPorts, getConsignmentDestinationPortsForConsignment, setLoadingAndDepartureReportAsReviewed, getConsignmentDaysForConsignmentID,
    patchLoadingReport,
    getEditPageReasons,
    getDetailedConsignment,
    getDetailedConsignmentDeparturePorts
} from '../api/apiAccess';
import { differenceInHours, differenceInMinutes } from 'date-fns';
import { MediaQueryContext, UserContext } from '..';
import { formatUpToSpecifiedPrecision } from '../utils/common';
import { getPortDateTimeUTC } from '../helpers/TimezoneHelper'
import ReadWriteButton from '../components/ReadWriteElements/ReadWriteButton';
import DateTimePicker from '../components/DateTimePicker';
import { FeedNumberValidationRules, NumericValidationRules, parseNumericInput } from '../utils/InputValidator';
import EditLogModal from '../components/EditLogModal';
import { StringIsNullUndefinedOrEmpty } from '../utils/StringUtils';
import { LoadingReportLivestockLoadedEdit, LoadingReportLivestockLoadedAddition, LoadingReportSave } from '../classes/LoadingReportSave';
import { FeedDetail } from '../classes/FeedDetail';
import ReadWriteInputGroup from '../components/ReadWriteElements/ReadWriteInputGroup';
import { Tooltip } from 'react-tooltip';
import { DetailedConsignment } from '../classes/DetailedConsignment';
import { usePortLocalDatetime } from '../hooks/usePortLocalDatetime';

const Voyage_Departure_And_Vessel_Loading = () => {
    const mediaQueryCtx = useContext(MediaQueryContext);
    const location = useLocation();
    const { consignmentDeparturePortID } = useParams();
    const userCtx = useContext(UserContext);
    const mobileHeaderRef = useRef();

    const navigate = useNavigate();

    const [consignmentID, setConsignmentID] = useState(-1);

    const [hasData, setHasData] = useState(false);
    const [loading, setIsLoading] = useState(false);
    const [loadError, setHasLoadError] = useState(false);
    const [saveError, setHasSaveError] = useState(false);
    const [saveErrorMessage, setHasSaveErrorMessage] = useState(false);
    const [saveSuccess, setHasSaveSuccess] = useState(false);

    const [canEdit, setCanEdit] = useState(true);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editModalShow, setEditModalShow] = useState(false);
    const [editPageReasons, setEditPageReasons] = useState([]);

    const [lncNumber, setLNCNumber] = useState("");
    const [portName, setPortName] = useState("");
    const [portID, setPortID] = useState("");

    const [departurePorts, setDeparturePorts] = useState([]);
    const [departurePort, setDeparturePort] = useState(undefined);
    const [destinationPorts, setDestinationPorts] = useState([]);

    const [loadingCommenced, setLoadingCommenced] = useState(null);
    const [loadingCommencedDateValid, setLoadingCommencedDateValid] = useState(true);
    const [loadingCommencedDateErrorMessage, setLoadingCommencedDateErrorMessage] = useState("");

    const [loadingCompleted, setLoadingCompleted] = useState(null);
    const [loadingCompletedDateValid, setLoadingCompletedDateValid] = useState(true);
    const [loadingCompletedDateErrorMessage, setLoadingCompletedDateErrorMessage] = useState("");

    const [vesselDeparted, setVesselDeparted] = useState(null);
    const [vesselDepartedDateValid, setVesselDepartedDateValid] = useState(true);
    const [vesselDepartedDateErrorMessage, setVesselDepartedDateErrorMessage] = useState("");
    const [loadingForHours, setLoadingForHours] = useState("");

    const [feedLoaded, setFeedLoaded] = useState({
        feedROBFromPreviousVoyage: {},
        feedLoadedAtPort: []
    });

    const [livestockPlanned, setLivestockPlanned] = useState([]);
    const [livestockLoaded, setLivestockLoaded] = useState([]);
    const [displayLivestock, setDisplayLivestock] = useState([]);

    const [livestockSpeciesTotals, setLivestockSpeciesTotals] = useState([]);

    const [canViewEverything, setCanViewEverything] = useState(false);


    const { value: loadingCommencedlocalDatetime } = usePortLocalDatetime(departurePort, loadingCommenced);
    const { value: loadingCompletedlocalDatetime } = usePortLocalDatetime(departurePort, loadingCompleted);
    const { value: vesselDepartedlocalDatetime } = usePortLocalDatetime(departurePort, vesselDeparted);

    const goBack = () => {
        navigate(-1, { state: { isHistorical: location?.state?.isHistorical } })
    }

    const populatePage = async () => {
        const updateIsReviewedStatus = async (consignment, isReviewed) => {
            if (userCtx.user?.orgTypeID === 1 && isReviewed === false) {
                await setLoadingAndDepartureReportAsReviewed(consignment);
            }
        }

        let lorgTypeID = userCtx.user.orgTypeID;

        let lDeparturePort = await getDetailedConsignmentDeparturePort(consignmentDeparturePortID);

        if (lDeparturePort?.status === 200) {
            setConsignmentID(lDeparturePort.data.consignmentDeparturePort.consignmentID);

            // regulatory users can only view this page if the day the loading report was competed has been submitted
            // ideally we would handle this at the database level, but this is difficult as the regulatory user still needs to know
            // the port exists even if it has not been submitted
            let lConsignmentDays = await getConsignmentDaysForConsignmentID(lDeparturePort.data.consignmentDeparturePort.consignmentID);

            if (lConsignmentDays.status === 200) {
                let lCanViewPage = true;
                if (userCtx.user?.orgTypeID === 2) {
                    if (lConsignmentDays.data.find(cd => cd.id === lDeparturePort.data.consignmentDeparturePort.consignmentDayID)) {
                        lCanViewPage = true;
                    }
                    else {
                        lCanViewPage = false;
                    }
                }

                if (lCanViewPage === true) {
                    setPortName(lDeparturePort.data.port.portName);
                    setPortID(lDeparturePort.data.port.id);
                    setLNCNumber(lDeparturePort.data.lncNumber);
                    setDeparturePort(lDeparturePort.data.port);

                    // set is reviewed to true
                    // this sets the base departure port and all feed only loading reports to be reviewed
                    updateIsReviewedStatus(lDeparturePort.data.consignmentDeparturePort.consignmentID, lDeparturePort.data.consignmentDeparturePort.isLoadingAndDepartureReviewed);

                    setLoadingCommenced(new Date(lDeparturePort.data.consignmentDeparturePort.loadingCommencedDateUTC));
                    setLoadingCompleted(new Date(lDeparturePort.data.consignmentDeparturePort.loadingCompletedDateUTC));
                    setVesselDeparted(new Date(lDeparturePort.data.consignmentDeparturePort.vesselDepartedDateUTC));

                    // get other information
                    const consignmentID = lDeparturePort.data.consignmentDeparturePort.consignmentID;

                    let lPromises = [
                        getDeparturePorts(),
                        getDetailedConsignmentDeparturePorts(consignmentID),
                        getDestinationPorts(),
                        getConsignmentDestinationPortsForConsignment(consignmentID),
                        getConsignmenLivestockLoadedForDeparturePort(consignmentDeparturePortID),
                        getEditPageReasons(),
                        getDetailedConsignment(consignmentID)
                    ];

                    if (lorgTypeID === 1 || lorgTypeID === 3) {
                        setCanViewEverything(true);
                        lPromises.push(getGroupedConsignmenPlannedLivestock(lDeparturePort.data.consignmentDeparturePort.consignmentID));
                    }
                    else {
                        setCanViewEverything(false);
                    }

                    Promise.all(lPromises)
                        .then(response => {
                            if (response && response.every(resp => resp?.status === 200)) {
                                let allDeparturePorts = response[0].data;
                                let lConsignmentDeparturePorts = response[1].data;
                                let lConsignmentDeparturePortsDetail = [];

                                let feedLoadedAtPorts = [];
                                let feedROBFromPreviousVoyage = {};

                                lConsignmentDeparturePorts.forEach(port => {
                                    const feedLoadedDetail = port.feedLoadedDetail;

                                    feedLoadedAtPorts.push({
                                        id: feedLoadedDetail.id,
                                        portName: port.port.portName,
                                        isFeedOnly: port.consignmentDeparturePort.isFeedOnly,
                                        pellets: feedLoadedDetail.pellets,
                                        grain: feedLoadedDetail.grain,
                                        roughage: feedLoadedDetail.roughage,
                                        pelletsValid: true,
                                        grainValid: true,
                                        roughageValid: true
                                    });

                                    if (!port.consignmentDeparturePort.isFeedOnly) {
                                        const robFeedDetail = port.feedROBDetail;

                                        feedROBFromPreviousVoyage = {
                                            id: robFeedDetail.id,
                                            portName: port.port.portName,
                                            isFeedOnly: port.consignmentDeparturePort.isFeedOnly,
                                            pellets: robFeedDetail.pellets,
                                            grain: robFeedDetail.grain,
                                            roughage: robFeedDetail.roughage,
                                            pelletsValid: true,
                                            grainValid: true,
                                            roughageValid: true
                                        }
                                    }

                                    if (!port.consignmentDeparturePort.isFeedOnly) {
                                        let portDetails = allDeparturePorts.find(p => Number(p.id) === Number(port.port.id));
                                        lConsignmentDeparturePortsDetail.push(portDetails);
                                    }
                                })
                                setFeedLoaded({
                                    feedROBFromPreviousVoyage: feedROBFromPreviousVoyage,
                                    feedLoadedAtPort: feedLoadedAtPorts
                                });
                                setDeparturePorts(lConsignmentDeparturePortsDetail);

                                let allDestinationPorts = response[2].data;
                                let lConsignmentDestinationPorts = response[3].data;
                                let lConsignmentDestinationPortsDetail = [];

                                lConsignmentDestinationPorts.forEach(port => {
                                    let portDetails = allDestinationPorts.find(p => Number(p.id) === Number(port.portID));
                                    lConsignmentDestinationPortsDetail.push(portDetails);
                                })
                                setDestinationPorts(lConsignmentDestinationPortsDetail);

                                const editReasons = response[5].data;
                                setEditPageReasons(editReasons);

                                const detailedConsignment = new DetailedConsignment(response[6].data);
                                const lIsEditable = detailedConsignment.IsEditableAfterEndOfVoyage();
                                setCanEdit(lIsEditable);

                                let lLivestockLoaded = response[4].data;

                                // Only certain users should see this information
                                if (lorgTypeID === 1 || lorgTypeID === 3) {
                                    let lLivestockPlanned = response[7].data;
                                    setLivestockPlanned(lLivestockPlanned);

                                    // We allow livestock to be added after the End of Voyage report has been completed.
                                    // If this happens, the new livestock needs to be included on the existing departure and discharge reports
                                    // It does not affect any daily records
                                    // We add any livestock in livestockPlanned that is not in liveStockLoaded to livestockLoaded and assign a unique negative ID
                                    // On save existing livestock loading rows are edited and any additions have new rows created
                                    let tempId = -1;

                                    lLivestockPlanned.forEach(plannedLivestock => {
                                        let lMatch = lLivestockLoaded.find(s => s.speciesID === plannedLivestock.speciesID && s.classID === plannedLivestock.classID);

                                        if (!lMatch) {
                                            // Planned animal count does not have an existing row in the DeparturePortLoadingAnimals table
                                            // We need to assign it a temp uniqueID so that the input update functions work
                                            lLivestockLoaded.push({
                                                ...plannedLivestock,
                                                id: tempId--,
                                                noPlanned: plannedLivestock.numberLoaded,
                                                numberLoaded: 0
                                            });
                                        }
                                    })
                                }

                                setLivestockLoaded(lLivestockLoaded);
                                return true;
                            }
                            else {
                                return false;
                            }
                        }).then(result => {
                            setHasData(result);
                            setHasLoadError(!result)
                            setIsLoading(false);
                        })
                        .catch(error => {
                            setHasLoadError(true)
                            setIsLoading(false);
                        })
                }
                else {
                    setHasData(false);
                    setHasLoadError(true)
                    setIsLoading(false);
                }
            }
            else {
                setHasData(false);
                setHasLoadError(true)
                setIsLoading(false);
            }
        }
        else {
            setHasLoadError(true)
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (consignmentDeparturePortID && userCtx.user) {
            setIsLoading(true)
            populatePage();
        }

    }, [consignmentDeparturePortID, userCtx.user])


    useEffect(() => {
        let lDisplayLivestock = [];
        livestockLoaded.forEach(livestock => {
            lDisplayLivestock.push({
                id: livestock.id,
                speciesID: livestock.speciesID,
                classID: livestock.classID,
                name: `${livestock.speciesName} - ${livestock.className}`,
                noLoaded: livestock.numberLoaded,
                noPlanned: 0
            });
        })

        livestockPlanned.forEach(plannedLivestock => {
            let lMatch = lDisplayLivestock.find(livestock => livestock.speciesID === plannedLivestock.speciesID && livestock.classID === plannedLivestock.classID);

            if (lMatch) {
                lMatch.noPlanned = plannedLivestock.numberLoaded;
            }
        })

        setDisplayLivestock(lDisplayLivestock);
    }, [livestockPlanned, livestockLoaded])

    useEffect(() => {
        let lSpeciesTotals = [];

        livestockLoaded.forEach(livestock => {
            let lMatch = lSpeciesTotals.find(species => species.id === livestock.speciesID);

            if (lMatch) {
                lMatch.count += livestock.numberLoaded
            }
            else {
                lSpeciesTotals.push({ id: livestock.speciesID, name: livestock.speciesName, count: livestock.numberLoaded });
            }
        })

        livestockPlanned.forEach(plannedLivestock => {
            let lMatch = lSpeciesTotals.find(s => s.id === plannedLivestock.speciesID);

            if (!lMatch) {
                lSpeciesTotals.push({ id: plannedLivestock.speciesID, name: plannedLivestock.speciesName, count: 0 });
            }
        })

        setLivestockSpeciesTotals(lSpeciesTotals);
    }, [livestockLoaded])


    useEffect(() => {
        if (loadingCommenced && loadingCompleted) {
            let lHours = differenceInHours(loadingCompleted, loadingCommenced);
            if (lHours === 1) {
                setLoadingForHours(lHours + " hour");
            }
            else {
                setLoadingForHours(lHours + " hours");
            }
        }
    }, [loadingCommenced, loadingCompleted])

    const updateLivestockLoaded = (id, numberLoaded) => {
        let lUpdatedLoaded = [...livestockLoaded];
        let lMatch = lUpdatedLoaded.find((obj) => obj.id === id);
        if (lMatch) {
            lMatch.numberLoaded = numberLoaded;
        }
        setLivestockLoaded(lUpdatedLoaded);
    };

    const updateFeedROBFromPreviousVoyage = (type, value) => {
        setFeedLoaded(prev => ({
            ...prev,
            feedROBFromPreviousVoyage: {
                ...prev.feedROBFromPreviousVoyage,
                [type]: value
            }
        }));
    };

    const updateFeedLoadedAtPort = (id, type, value) => {
        setFeedLoaded(prev => ({
            ...prev,
            feedLoadedAtPort: prev.feedLoadedAtPort.map(item =>
                item.id === id
                    ? { ...item, [type]: value }
                    : item
            )
        }));
    };

    const updateFeedROBValidity = (field, isValid) => {
        setFeedLoaded(prev => ({
            ...prev,
            feedROBFromPreviousVoyage: {
                ...prev.feedROBFromPreviousVoyage,
                [field]: isValid
            }
        }));
    };

    const updateFeedLoadedAtPortValidity = (feedID, field, isValid) => {
        setFeedLoaded(prev => ({
            ...prev,
            feedLoadedAtPort: prev.feedLoadedAtPort.map(item =>
                item.id === feedID
                    ? {
                        ...item,
                        [field]: isValid
                    }
                    : item
            )
        }));
    };

    const safeNumber = value => {
        const num = parseFloat(value);
        return isNaN(num) ? 0 : num;
    };

    const totalPelletsLoaded = useMemo(() => {
        if (!feedLoaded) return 0;

        const prevPellets = safeNumber(feedLoaded.feedROBFromPreviousVoyage?.pellets);

        const portPellets = (feedLoaded.feedLoadedAtPort || []).reduce(
            (sum, item) => sum + safeNumber(item.pellets),
            0
        );

        return (prevPellets + portPellets).toFixed(2);
    }, [feedLoaded]);

    const totalGrainLoaded = useMemo(() => {
        if (!feedLoaded) return 0;

        const prevGrain = safeNumber(feedLoaded.feedROBFromPreviousVoyage?.grain);

        const portGrain = (feedLoaded.feedLoadedAtPort || []).reduce(
            (sum, item) => sum + safeNumber(item.grain),
            0
        );

        return (prevGrain + portGrain).toFixed(2);
    }, [feedLoaded]);

    const totalRoughageLoaded = useMemo(() => {
        if (!feedLoaded) return 0;

        const prevRoughage = safeNumber(feedLoaded.feedROBFromPreviousVoyage?.roughage);

        const portRoughage = (feedLoaded.feedLoadedAtPort || []).reduce(
            (sum, item) => sum + safeNumber(item.roughage),
            0
        );

        return (prevRoughage + portRoughage).toFixed(2);
    }, [feedLoaded]);

    const cancelEdit = () => {
        setIsEditMode(false);
        populatePage();
    };

    const onEditModalClosed = () => {
        setEditModalShow(false);
    };

    const onEditModalSaveSuccess = () => {
        save();
    };

    const onEditModalSaveFailed = () => {
        // do nothing generic error message is displayed inside the modal
    };

    const validateAndShowEditModal = (e) => {
        const validateDates = () => {
            // Dates must not be null or empty
            // Vessel departed date > Loading completed date
            // Loading completed date > Loading commenced date

            let lLoadingCommencedDateValid = !StringIsNullUndefinedOrEmpty(loadingCommenced);
            setLoadingCommencedDateValid(lLoadingCommencedDateValid);
            if (lLoadingCommencedDateValid) {
                setLoadingCommencedDateErrorMessage("");
            }
            else {
                setLoadingCommencedDateErrorMessage("A loading commenced date and time is required.");
            }

            let lLoadingCompletedDateValid = false;
            if (!StringIsNullUndefinedOrEmpty(loadingCompleted)) {
                if (lLoadingCommencedDateValid && differenceInMinutes(loadingCompleted, loadingCommenced) <= 0) {
                    lLoadingCompletedDateValid = false;
                    setLoadingCompletedDateErrorMessage("The loading completed date must be after the loading commenced date.");
                } else {
                    setLoadingCompletedDateErrorMessage("");
                    lLoadingCompletedDateValid = true;
                }
            } else {
                setLoadingCompletedDateErrorMessage("A loading completed date and time is required.");
                lLoadingCompletedDateValid = false;
            }
            setLoadingCompletedDateValid(lLoadingCompletedDateValid);

            let lVesselDepartedDateValid = false;
            if (!StringIsNullUndefinedOrEmpty(vesselDeparted)) {
                if (lLoadingCompletedDateValid && differenceInMinutes(vesselDeparted, loadingCompleted) <= 0) {
                    lVesselDepartedDateValid = false;
                    setVesselDepartedDateErrorMessage("The vessel departed date must be after the loading completed date.");
                } else {
                    setVesselDepartedDateErrorMessage("");
                    lVesselDepartedDateValid = true;
                }
            } else {
                setVesselDepartedDateErrorMessage("A vessel departed date and time is required.");
                lVesselDepartedDateValid = false;
            }
            setVesselDepartedDateValid(lVesselDepartedDateValid);

            return lLoadingCommencedDateValid && lLoadingCompletedDateValid && lVesselDepartedDateValid;
        };

        const validateFeed = () => {
            // feed ROB
            let lROBPelletsValid = false;
            let lROBGrainValid = false;
            let lROBRoughageValid = false;

            if (feedLoaded?.feedROBFromPreviousVoyage) {
                if (!StringIsNullUndefinedOrEmpty(feedLoaded?.feedROBFromPreviousVoyage?.pellets) && !isNaN(feedLoaded?.feedROBFromPreviousVoyage?.pellets)) {
                    lROBPelletsValid = true;
                }
                if (!StringIsNullUndefinedOrEmpty(feedLoaded?.feedROBFromPreviousVoyage?.grain) && !isNaN(feedLoaded?.feedROBFromPreviousVoyage?.grain)) {
                    lROBGrainValid = true;
                }
                if (!StringIsNullUndefinedOrEmpty(feedLoaded?.feedROBFromPreviousVoyage?.roughage) && !isNaN(feedLoaded?.feedROBFromPreviousVoyage?.roughage)) {
                    lROBRoughageValid = true;
                }
            }

            updateFeedROBValidity("pelletsValid", lROBPelletsValid);
            updateFeedROBValidity("grainValid", lROBGrainValid);
            updateFeedROBValidity("roughageValid", lROBRoughageValid);

            const feedROBValid = lROBPelletsValid && lROBGrainValid && lROBRoughageValid;

            // feed loaded at port
            let feedLoadedValid = true;

            feedLoaded?.feedLoadedAtPort.forEach(feedLoadedPort => {
                let loadedPelletsValid = false;
                let loadedGrainValid = false;
                let loadedRoughageValid = false;

                if (!StringIsNullUndefinedOrEmpty(feedLoadedPort?.pellets) && !isNaN(feedLoadedPort?.pellets)) {
                    loadedPelletsValid = true;
                }
                if (!StringIsNullUndefinedOrEmpty(feedLoadedPort?.grain) && !isNaN(feedLoadedPort?.grain)) {
                    loadedGrainValid = true;
                }
                if (!StringIsNullUndefinedOrEmpty(feedLoadedPort?.roughage) && !isNaN(feedLoadedPort?.roughage)) {
                    loadedRoughageValid = true;
                }

                updateFeedLoadedAtPortValidity(feedLoadedPort.id, "pelletsValid", loadedPelletsValid);
                updateFeedLoadedAtPortValidity(feedLoadedPort.id, "grainValid", loadedGrainValid);
                updateFeedLoadedAtPortValidity(feedLoadedPort.id, "roughageValid", loadedRoughageValid);

                if (!loadedPelletsValid || !loadedGrainValid || !loadedRoughageValid) {
                    feedLoadedValid = false;
                }
            })

            return feedROBValid && feedLoadedValid;
        };

        const validate = () => {
            const datesValid = validateDates();
            const feedValid = validateFeed();

            if (datesValid && feedValid) {
                return true;
            } else {
                return false;
            }
        };

        e.preventDefault();
        setHasSaveError(false);
        setHasSaveSuccess(false);

        let lValid = validate();

        if (lValid === true) {
            setEditModalShow(true);
        } else {
            setEditModalShow(false);
            setHasSaveError(true);
            setHasSaveErrorMessage("Unable to save departure report. Please address any validation issues.");
        }
    };

    // at this point the page should have already been validated
    const save = () => {
        const writeToDb = async () => {
            setEditModalShow(false);

            // create object to save
            let lUpdatedLoadingAnimals = [];
            let lNewLoadingAniamls = [];

            livestockLoaded.forEach((livestock) => {
                if (livestock.id > 0) {
                    lUpdatedLoadingAnimals.push(new LoadingReportLivestockLoadedEdit(livestock.id, Number(livestock.numberLoaded)));
                }
                else {
                    lNewLoadingAniamls.push(new LoadingReportLivestockLoadedAddition(Number(livestock.numberLoaded), Number(livestock.speciesID), Number(livestock.classID)));
                }
            });

            const feedROBObj = {
                id: feedLoaded?.feedROBFromPreviousVoyage?.id,
                pellets: parseFloat(feedLoaded?.feedROBFromPreviousVoyage?.pellets),
                grain: parseFloat(feedLoaded?.feedROBFromPreviousVoyage?.grain),
                roughage: parseFloat(feedLoaded?.feedROBFromPreviousVoyage?.roughage),
            }
            const updatedFeedROB = new FeedDetail(feedROBObj);

            const updatedFeedLoadedAtPort = feedLoaded?.feedLoadedAtPort?.map(feed => (
                new FeedDetail({
                    id: feed.id,
                    pellets: parseFloat(feed.pellets) || 0,
                    grain: parseFloat(feed.grain) || 0,
                    roughage: parseFloat(feed.roughage) || 0,
                })));

            let lLoadingReportObj = new LoadingReportSave(
                loadingCommenced.toISOString(),
                loadingCompleted.toISOString(),
                vesselDeparted.toISOString(),
                lUpdatedLoadingAnimals,
                lNewLoadingAniamls,
                updatedFeedROB,
                updatedFeedLoadedAtPort
            );

            let lResult = await patchLoadingReport(consignmentDeparturePortID, lLoadingReportObj);
            if (lResult?.status === 200) {
                setHasSaveSuccess(true);
                setTimeout(() => {
                    setHasSaveSuccess(false);
                }, 15000);
                setIsEditMode(false);
            } else {
                setHasSaveError(true);
                setHasSaveErrorMessage("Something went wrong while trying to save.");
            }
        };
        writeToDb();
    };

    return (
        <LoggedInContainer>
            <Container fluid className="p-0" style={{ backgroundColor: "#F5F5F5" }}>
                <Row className="upper-panel mx-0" style={{ position: "relative" }}>
                    <Col>
                        <Container>
                            <Row style={{ marginTop: mediaQueryCtx.mobile === true ? "40px" : "65px" }}>
                                {
                                    mediaQueryCtx.mobile === true ? (
                                        <Container fluid ref={mobileHeaderRef}>
                                            <Row>
                                                <Col xs={12} style={{ marginTop: "20px" }}>
                                                    <div className="text-center heading-text mb-2 mt-3" style={{ color: "#FFF" }}>
                                                        <div style={{ lineHeight: "53px", fontSize: "35px" }}>View Voyage Departure and Vessel Loading</div>
                                                        <div>LNC- {lncNumber}</div>
                                                    </div>
                                                </Col>
                                                <Col xs={12} className="text-center">
                                                    <Button className="w-100 mt-3" variant="back" onClick={() => goBack()}>
                                                        <FontAwesomeIcon icon={faCaretLeft} style={{ marginRight: "5px" }} />Back
                                                    </Button>
                                                </Col>
                                                <Col xs={12} className="mt-3" style={{ textAlign: "right" }}>
                                                    {loading === false && isEditMode === false && canEdit ? (
                                                        <ReadWriteButton className="w-100" writeonly={true} variant="back" onClick={() => setIsEditMode(true)}>
                                                            Edit Departure
                                                        </ReadWriteButton>
                                                    ) : null}
                                                </Col>
                                            </Row>
                                        </Container>
                                    ) : (
                                        <>
                                            <Col xs={2}>
                                                <Button variant="back" onClick={() => goBack()}>
                                                    <FontAwesomeIcon icon={faCaretLeft} style={{ marginRight: "5px" }} />Back
                                                </Button>
                                            </Col>
                                            <Col>
                                                <div className="text-center heading-text mb-2 mt-3" style={{ color: "#FFF", display: "inline" }}>
                                                    <div style={{ lineHeight: "53px", fontSize: "35px" }}>View Voyage Departure and Vessel Loading</div>
                                                    <div>LNC- {lncNumber}</div>
                                                </div>
                                            </Col>
                                            <Col xs={2} style={{ textAlign: "right" }}>
                                                {loading === false && isEditMode === false && canEdit ? (
                                                    <ReadWriteButton writeonly={true} variant="back" onClick={() => setIsEditMode(true)}>
                                                        Edit Departure
                                                    </ReadWriteButton>
                                                ) : null}
                                            </Col>
                                        </>
                                    )
                                }
                            </Row>
                        </Container>
                    </Col>
                </Row>
                <Container className="py-4 px-5 form-container-full" style={{ marginTop: mediaQueryCtx.mobile === true ? (mobileHeaderRef?.current?.offsetHeight ? `${mobileHeaderRef?.current?.offsetHeight - 130}px` : "120px") : "inherit" }}>
                    {
                        loading === true ? (
                            <Row>
                                <Col>
                                    <div className="text-center pt-5">
                                        <Spinner className="mx-auto" />
                                        <div className="mx-auto">Loading data...</div>
                                    </div>
                                </Col>
                            </Row>
                        ) : null
                    }
                    {
                        hasData === true && loading == false ?
                            <>
                                <Row className='mb-4'>
                                    <Col>
                                        <Row className="mt-3">
                                            <Col xs={12}>
                                                <div className="green-underline-heading">Voyage Summary</div>
                                            </Col>
                                            <Row className='mb-3'>
                                                <Col xs={12} md={3}>
                                                    <div className="field-label">
                                                        Loading In
                                                    </div>
                                                    {
                                                        departurePorts.filter(p => p).map((port, i) => {
                                                            return (
                                                                <div key={`departurePort_${port.id}`} className={port.id === portID ? "bold text-13-400 secondary-grey" : "text-13-400 secondary-grey"}>{port.portName}</div> ///todo bold port we are currently viewing
                                                            );
                                                        })
                                                    }
                                                </Col>
                                                <Col xs={12} md={3}>
                                                    <div className="field-label">
                                                        Discharging In
                                                    </div>
                                                    {
                                                        destinationPorts.map((port, i) => {
                                                            return (
                                                                <div className='text-13-400 secondary-grey' key={`destinationPort_${port.id}`}>{port.portName}, {port.countryName}</div>
                                                            );
                                                        })
                                                    }
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs={12} md={3}>
                                                    <Stack>
                                                        <div className="field-label">Loading Commenced</div>
                                                        {
                                                            isEditMode === false ? (
                                                                <>
                                                                    <div className='text-13-400 secondary-grey'>
                                                                        {
                                                                            loadingCommenced ?
                                                                                getPortDateTimeUTC(departurePorts.find(dp => dp.id === Number(portID)), loadingCommenced) + " UTC"
                                                                                : ""
                                                                        }
                                                                    </div>
                                                                    <div className='text-13-400 secondary-grey'>
                                                                        {
                                                                            loadingCommenced ? loadingCommencedlocalDatetime : ""
                                                                        }
                                                                    </div>
                                                                </>
                                                            )
                                                                :
                                                                (
                                                                    <DateTimePicker
                                                                        port={departurePorts.find((dp) => dp.id === Number(portID))}
                                                                        datetime={loadingCommenced}
                                                                        isValid={loadingCommencedDateValid}
                                                                        errorMessage={loadingCommencedDateErrorMessage}
                                                                        showTime={true}
                                                                        showUTCTime={true}
                                                                        onChange={(date) => {
                                                                            setLoadingCommencedDateValid(true);
                                                                            setLoadingCommenced(date);
                                                                        }}
                                                                        showHeadLabel={false}
                                                                        endLabel="Local Time"
                                                                    />
                                                                )
                                                        }

                                                    </Stack>
                                                </Col>
                                                <Col xs={12} md={3}>
                                                    <Stack>
                                                        <div className="field-label">Loading Completed</div>
                                                        {
                                                            isEditMode === false ?
                                                                <>
                                                                    <div className='text-13-400 secondary-grey'>
                                                                        {
                                                                            loadingCompleted ?
                                                                                getPortDateTimeUTC(departurePorts.find(dp => dp.id === Number(portID)), loadingCompleted) + " UTC"
                                                                                : ""
                                                                        }
                                                                    </div>
                                                                    <div className='text-13-400 secondary-grey'>
                                                                        {
                                                                            loadingCompleted ? loadingCompletedlocalDatetime : ""
                                                                        }
                                                                    </div>
                                                                </>
                                                                :
                                                                <DateTimePicker
                                                                    port={departurePorts.find((dp) => dp.id === Number(portID))}
                                                                    datetime={loadingCompleted}
                                                                    isValid={loadingCompletedDateValid}
                                                                    errorMessage={loadingCompletedDateErrorMessage}
                                                                    showTime={true}
                                                                    showUTCTime={true}
                                                                    onChange={(date) => {
                                                                        setLoadingCompletedDateValid(true);
                                                                        setLoadingCompleted(date);
                                                                    }}
                                                                    showHeadLabel={false}
                                                                    endLabel="Local Time"
                                                                />
                                                        }


                                                        {
                                                            loadingCommenced && loadingCompleted ?
                                                                <div className='italic text-13-400 secondary-grey'>Loading for {loadingForHours}</div>
                                                                : null
                                                        }
                                                    </Stack>
                                                </Col>
                                                <Col xs={12} md={3}>
                                                    <Stack>
                                                        <div className="field-label">Vessel Departed</div>
                                                        {
                                                            isEditMode === false ?
                                                                <>
                                                                    <div className='text-13-400 secondary-grey'>
                                                                        {
                                                                            vesselDeparted ?
                                                                                getPortDateTimeUTC(departurePorts.find(dp => dp.id === Number(portID)), vesselDeparted) + " UTC"
                                                                                : ""
                                                                        }
                                                                        <div className='text-13-400 secondary-grey'>
                                                                            {
                                                                                vesselDeparted ? vesselDepartedlocalDatetime : ""
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </>
                                                                :
                                                                <DateTimePicker
                                                                    port={departurePorts.find((dp) => dp.id === Number(portID))}
                                                                    datetime={vesselDeparted}
                                                                    isValid={vesselDepartedDateValid}
                                                                    errorMessage={vesselDepartedDateErrorMessage}
                                                                    showTime={true}
                                                                    showUTCTime={true}
                                                                    onChange={(date) => {
                                                                        setVesselDepartedDateValid(true);
                                                                        setVesselDeparted(date);
                                                                    }}
                                                                    showHeadLabel={false}
                                                                    endLabel="Local Time"
                                                                />
                                                        }

                                                    </Stack>
                                                </Col>
                                            </Row>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className='mb-4'>
                                    <Col>
                                        <Row>
                                            <Col xs={12}>
                                                <div className="green-underline-heading">Livestock Loaded</div>
                                            </Col>
                                        </Row>
                                        {
                                            canViewEverything && displayLivestock.some(liv => liv.noLoaded !== liv.noPlanned) ?
                                                <Row>
                                                    <Col>
                                                        <Alert variant='danger'>
                                                            <Stack direction='horizontal' gap={3}>
                                                                <FontAwesomeIcon icon={faExclamationCircle} />
                                                                <div className='text-13-400'>Update the consignment details with the final livestock numbers, weights, and management plans, as these determine ASEL feed requirements. Use the "change livestock" function on the consignment setup page.</div>
                                                            </Stack>
                                                        </Alert>
                                                    </Col>
                                                </Row>
                                                : null
                                        }
                                        <Row>
                                            <Col xs={12} md={6}>
                                                <Row>
                                                    <Col xs={12}>
                                                        <Row className='pb-1'>
                                                            <Col className="field-label darkblue">Species / Class</Col>
                                                            {
                                                                canViewEverything ?
                                                                    <Col className="field-label darkblue">No. In Consignment Setup</Col>
                                                                    : null
                                                            }
                                                            <Col className="field-label darkblue">No. Loaded</Col>
                                                        </Row>
                                                        {
                                                            displayLivestock.map((livestock, i) => {
                                                                return (
                                                                    <Row key={`livestock_loading_${i}`} className='pb-2'>
                                                                        <Col className='text-13-400 secondary-grey'>{livestock.name}</Col>
                                                                        {
                                                                            canViewEverything ?
                                                                                <Col className='text-13-400 secondary-grey'>{livestock.noPlanned}</Col>
                                                                                : null
                                                                        }
                                                                        <Col>
                                                                            <Stack direction='horizontal' gap={2}>
                                                                                {
                                                                                    isEditMode === false ?
                                                                                        <div className='text-13-400 secondary-grey'>{livestock.noLoaded}</div> :
                                                                                        <Form.Group>
                                                                                            <Form.Control
                                                                                                id={`livestock_loaded_input_${i}`}
                                                                                                className="input"
                                                                                                value={livestock.noLoaded}
                                                                                                onChange={(e) => {
                                                                                                    parseNumericInput(
                                                                                                        e,
                                                                                                        new NumericValidationRules({
                                                                                                            allowDecimal: false,
                                                                                                            allowNegative: false,
                                                                                                            allowLeadingZerosForWholeNumbers: false,
                                                                                                            allowSingleZero: true,
                                                                                                            minRange: 0,
                                                                                                        })
                                                                                                    );
                                                                                                    const numValue = Number(e.target.value);
                                                                                                    updateLivestockLoaded(livestock.id, isNaN(numValue) ? 0 : numValue);
                                                                                                }}
                                                                                                onFocus={() => {
                                                                                                    if (Number(livestock.noLoaded) === 0) {
                                                                                                        updateLivestockLoaded(livestock.id, 0);
                                                                                                    }
                                                                                                }}
                                                                                                onBlur={(e) => {
                                                                                                    if (e.target.value === "") {
                                                                                                        updateLivestockLoaded(livestock.id, 0);
                                                                                                    }
                                                                                                }}
                                                                                            />
                                                                                        </Form.Group>
                                                                                }

                                                                                {
                                                                                    canViewEverything && livestock.noPlanned !== livestock.noLoaded ?
                                                                                        <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "#664d03" }} />
                                                                                        : null
                                                                                }
                                                                            </Stack>
                                                                        </Col>
                                                                    </Row>
                                                                );
                                                            })
                                                        }
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col xs={12} md={4}>
                                                <div className="bg-grey-transparent p-3">
                                                    <div className="field-label mb-2">Livestock Total Loaded</div>
                                                    {
                                                        livestockSpeciesTotals.map((livestock, index) => (
                                                            <Row key={"livestockLoaded" + index} className="mb-2">
                                                                <Col xs={8} className="field-label">{livestock.name}</Col>
                                                                <Col xs={4} className="field-label">{livestock.count}</Col>
                                                            </Row>
                                                        ))
                                                    }
                                                    <Row>
                                                        <Col xs={8} className="field-label">Total Head</Col>
                                                        <Col xs={4} className="field-label">
                                                            {
                                                                livestockSpeciesTotals.reduce((sum, livestock) => sum + livestock.count, 0)
                                                            }
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Row>
                                            <Col xs={12}>
                                                <div className="green-underline-heading">Feed Loaded</div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={12} md={6}>
                                                <Row className='mb-1'>
                                                    <Col xs={6}></Col>
                                                    <Col xs={2} className="text-center field-label">Pellets</Col>
                                                    <Col xs={2} className="text-center field-label">Grain</Col>
                                                    <Col xs={2} className="text-center field-label">Roughage</Col>
                                                </Row>
                                                <Row className="mb-2 pb-2 cc-port-loading-feed">
                                                    <Col xs={6} className="cc-feed-plan-row-label">ROB from previous voyage</Col>
                                                    <Col xs={2}>
                                                        {
                                                            !isEditMode ?
                                                                <div className='cc-feed-input p-0'>{feedLoaded.feedROBFromPreviousVoyage.pellets}t</div> :
                                                                <Form.Group>
                                                                    <InputGroup readonlyclasses="text-13-400 secondary-grey">
                                                                        <Form.Control
                                                                            id="robPellets"
                                                                            value={feedLoaded.feedROBFromPreviousVoyage.pellets}
                                                                            onChange={(e) => {
                                                                                e.preventDefault();
                                                                                parseNumericInput(e, FeedNumberValidationRules);
                                                                                updateFeedROBFromPreviousVoyage("pellets", e.target.value);
                                                                                updateFeedROBValidity("pelletsValid", true);
                                                                            }}
                                                                            className="inputGroupWithAppend errorLeft text-13-400 secondary-grey"
                                                                            isInvalid={!feedLoaded.feedROBFromPreviousVoyage.pelletsValid}
                                                                        />
                                                                        <InputGroup.Text className={`inputGroupAppend text-13-400 secondary-grey ${!feedLoaded.feedROBFromPreviousVoyage.pelletsValid ? "invalidAppend" : ""}`}>
                                                                            t
                                                                        </InputGroup.Text>
                                                                        {!feedLoaded.feedROBFromPreviousVoyage.pelletsValid ? (
                                                                            <div className="validation-error-tooltip">
                                                                                <Tooltip
                                                                                    anchorSelect={`#robPellets`}
                                                                                    place="top"
                                                                                    variant="error"
                                                                                    content="A valid pellets ROB is requried."
                                                                                />
                                                                            </div>
                                                                        ) : null}
                                                                    </InputGroup>
                                                                </Form.Group>
                                                        }
                                                    </Col>
                                                    <Col xs={2}>
                                                        {
                                                            !isEditMode ?
                                                                <div className='cc-feed-input p-0'>{feedLoaded.feedROBFromPreviousVoyage.grain}t</div> :
                                                                <Form.Group>
                                                                    <InputGroup readonlyclasses="text-13-400 secondary-grey">
                                                                        <Form.Control
                                                                            id="robGrain"
                                                                            value={feedLoaded.feedROBFromPreviousVoyage.grain}
                                                                            onChange={(e) => {
                                                                                e.preventDefault();
                                                                                parseNumericInput(e, FeedNumberValidationRules);
                                                                                updateFeedROBFromPreviousVoyage("grain", e.target.value);
                                                                                updateFeedROBValidity("grainValid", true);
                                                                            }}
                                                                            className="inputGroupWithAppend errorLeft text-13-400 secondary-grey"
                                                                            isInvalid={!feedLoaded.feedROBFromPreviousVoyage.grainValid}
                                                                        />
                                                                        <InputGroup.Text className={`inputGroupAppend ${!feedLoaded.feedROBFromPreviousVoyage.grainValid ? "invalidAppend" : ""}`}>
                                                                            t
                                                                        </InputGroup.Text>
                                                                        {!feedLoaded.feedROBFromPreviousVoyage.grainValid ? (
                                                                            <div className="validation-error-tooltip">
                                                                                <Tooltip
                                                                                    anchorSelect={`#robGrain`}
                                                                                    place="top"
                                                                                    variant="error"
                                                                                    content="A valid grain ROB is requried."
                                                                                />
                                                                            </div>
                                                                        ) : null}
                                                                    </InputGroup>
                                                                </Form.Group>
                                                        }
                                                    </Col>
                                                    <Col xs={2}>
                                                        {
                                                            !isEditMode ?
                                                                <div className='cc-feed-input p-0'>{feedLoaded.feedROBFromPreviousVoyage.roughage}t</div> :
                                                                <Form.Group>
                                                                    <ReadWriteInputGroup readonlyclasses="text-13-400 secondary-grey">
                                                                        <Form.Control
                                                                            id="robRoughage"
                                                                            value={feedLoaded.feedROBFromPreviousVoyage.roughage}
                                                                            onChange={(e) => {
                                                                                e.preventDefault();
                                                                                parseNumericInput(e, FeedNumberValidationRules);
                                                                                updateFeedROBFromPreviousVoyage("roughage", e.target.value);
                                                                                updateFeedROBValidity("roughageValid", true);
                                                                            }}
                                                                            className="inputGroupWithAppend errorLeft text-13-400 secondary-grey"
                                                                            isInvalid={!feedLoaded.feedROBFromPreviousVoyage.roughageValid}
                                                                        />
                                                                        <InputGroup.Text className={`inputGroupAppend ${!feedLoaded.feedROBFromPreviousVoyage.roughageValid ? "invalidAppend" : ""}`}>
                                                                            t
                                                                        </InputGroup.Text>
                                                                        {feedLoaded.feedROBFromPreviousVoyage.roughageValid === false ? (
                                                                            <div className="validation-error-tooltip">
                                                                                <Tooltip
                                                                                    anchorSelect={`#robRoughage`}
                                                                                    place="top"
                                                                                    variant="error"
                                                                                    content="A valid roughage ROB is requried."
                                                                                />
                                                                            </div>
                                                                        ) : null}
                                                                    </ReadWriteInputGroup>
                                                                </Form.Group>
                                                        }
                                                    </Col>
                                                </Row>
                                                {
                                                    feedLoaded.feedLoadedAtPort.map((feed, index) => {
                                                        return (
                                                            <Row key={`feed_${index}_${feed.id}`} className="mb-3">
                                                                <Col xs={6} className="cc-feed-plan-row-label">
                                                                    Loaded in {feed.portName} {!feed.isFeedOnly ? "(Departure)" : "(feed-only)"}
                                                                </Col>
                                                                <Col xs={2}>
                                                                    {
                                                                        !isEditMode ?
                                                                            <div className='cc-feed-input p-0'>{feed.pellets}t</div> :
                                                                            <Form.Group>
                                                                                <InputGroup readonlyclasses="text-13-400 secondary-grey">
                                                                                    <Form.Control
                                                                                        id="pelletsLoaded"
                                                                                        value={feed.pellets}
                                                                                        onChange={(e) => {
                                                                                            e.preventDefault();
                                                                                            parseNumericInput(e, FeedNumberValidationRules);
                                                                                            updateFeedLoadedAtPort(feed.id, "pellets", e.target.value);
                                                                                            updateFeedLoadedAtPortValidity(feed.id, "pelletsValid", true);
                                                                                        }}
                                                                                        className="inputGroupWithAppend errorLeft text-13-400 secondary-grey"
                                                                                        isInvalid={!feed.pelletsValid}
                                                                                    />
                                                                                    <InputGroup.Text className={`inputGroupAppend ${!feed.pelletsValid ? "invalidAppend" : ""}`}>
                                                                                        t
                                                                                    </InputGroup.Text>
                                                                                    {!feed.pelletsValid ? (
                                                                                        <div className="validation-error-tooltip">
                                                                                            <Tooltip
                                                                                                anchorSelect={`#pelletsLoaded`}
                                                                                                place="top"
                                                                                                variant="error"
                                                                                                content="A valid pellets loaded is requried."
                                                                                            />
                                                                                        </div>
                                                                                    ) : null}
                                                                                </InputGroup>
                                                                            </Form.Group>
                                                                    }
                                                                </Col>
                                                                <Col xs={2}>
                                                                    {
                                                                        !isEditMode ?
                                                                            <div className='cc-feed-input p-0'>{feed.grain}t</div> :
                                                                            <Form.Group>
                                                                                <InputGroup readonlyclasses="text-13-400 secondary-grey">
                                                                                    <Form.Control
                                                                                        id="grainLoaded"
                                                                                        value={feed.grain}
                                                                                        onChange={(e) => {
                                                                                            e.preventDefault();
                                                                                            parseNumericInput(e, FeedNumberValidationRules);
                                                                                            updateFeedLoadedAtPort(feed.id, "grain", e.target.value);
                                                                                            updateFeedLoadedAtPortValidity(feed.id, "grainValid", true);
                                                                                        }}
                                                                                        className="inputGroupWithAppend errorLeft text-13-400 secondary-grey"
                                                                                        isInvalid={!feed.grainValid}
                                                                                    />
                                                                                    <InputGroup.Text className={`inputGroupAppend ${!feed.grainValid ? "invalidAppend" : ""}`}>
                                                                                        t
                                                                                    </InputGroup.Text>
                                                                                    {!feed.grainValid ? (
                                                                                        <div className="validation-error-tooltip">
                                                                                            <Tooltip
                                                                                                anchorSelect={`#grainLoaded`}
                                                                                                place="top"
                                                                                                variant="error"
                                                                                                content="A valid grain loaded is requried."
                                                                                            />
                                                                                        </div>
                                                                                    ) : null}
                                                                                </InputGroup>
                                                                            </Form.Group>
                                                                    }
                                                                </Col>
                                                                <Col xs={2}>
                                                                    {
                                                                        !isEditMode ?
                                                                            <div className='cc-feed-input p-0'>{feed.roughage}t</div> :
                                                                            <Form.Group>
                                                                                <InputGroup readonlyclasses="text-13-400 secondary-grey">
                                                                                    <Form.Control
                                                                                        id="roughageLoaded"
                                                                                        value={feed.roughage}
                                                                                        onChange={(e) => {
                                                                                            e.preventDefault();
                                                                                            parseNumericInput(e, FeedNumberValidationRules);
                                                                                            updateFeedLoadedAtPort(feed.id, "roughage", e.target.value);
                                                                                            updateFeedLoadedAtPortValidity(feed.id, "roughageValid", true);
                                                                                        }}
                                                                                        className="inputGroupWithAppend errorLeft text-13-400 secondary-grey"
                                                                                        isInvalid={!feed.roughageValid}
                                                                                    />
                                                                                    <InputGroup.Text className={`inputGroupAppend ${!feed.roughageValid ? "invalidAppend" : ""}`}>
                                                                                        t
                                                                                    </InputGroup.Text>
                                                                                    {!feed.roughageValid ? (
                                                                                        <div className="validation-error-tooltip">
                                                                                            <Tooltip
                                                                                                anchorSelect={`#roughageLoaded`}
                                                                                                place="top"
                                                                                                variant="error"
                                                                                                content="A valid roughage loaded is requried."
                                                                                            />
                                                                                        </div>
                                                                                    ) : null}
                                                                                </InputGroup>
                                                                            </Form.Group>
                                                                    }
                                                                </Col>
                                                            </Row>
                                                        )
                                                    })
                                                }
                                                {/* <Row className="mb-3">
                                                    <Col xs={6} className="cc-feed-plan-row-label">Loaded in {portName} (Departure)</Col>
                                                    <Col xs={2}>
                                                        {
                                                            !isEditMode ?
                                                                <div className='cc-feed-input p-0'>{pelletsLoaded}t</div> :
                                                                <Form.Group>
                                                                    <InputGroup readonlyclasses="text-13-400 secondary-grey">
                                                                        <Form.Control
                                                                            id="pelletsLoaded"
                                                                            value={pelletsLoaded}
                                                                            onChange={(e) => {
                                                                                e.preventDefault();
                                                                                parseNumericInput(e, FeedNumberValidationRules);
                                                                                setPelletsLoaded(e.target.value);
                                                                                setPelletsLoadedValid(true);
                                                                            }}
                                                                            className="inputGroupWithAppend errorLeft text-13-400 secondary-grey"
                                                                            isInvalid={!pelletsLoadedValid}
                                                                        />
                                                                        <InputGroup.Text className={`inputGroupAppend ${!pelletsLoadedValid ? "invalidAppend" : ""}`}>
                                                                            t
                                                                        </InputGroup.Text>
                                                                        {!pelletsLoadedValid ? (
                                                                            <div className="validation-error-tooltip">
                                                                                <Tooltip
                                                                                    anchorSelect={`#pelletsLoaded`}
                                                                                    place="top"
                                                                                    variant="error"
                                                                                    content="A valid pellets loaded is requried."
                                                                                />
                                                                            </div>
                                                                        ) : null}
                                                                    </InputGroup>
                                                                </Form.Group>
                                                        }
                                                    </Col>
                                                    <Col xs={2}>
                                                        {
                                                            !isEditMode ?
                                                                <div className='cc-feed-input p-0'>{grainLoaded}t</div> :
                                                                <Form.Group>
                                                                    <InputGroup readonlyclasses="text-13-400 secondary-grey">
                                                                        <Form.Control
                                                                            id="grainLoaded"
                                                                            value={grainLoaded}
                                                                            onChange={(e) => {
                                                                                e.preventDefault();
                                                                                parseNumericInput(e, FeedNumberValidationRules);
                                                                                setGrainLoaded(e.target.value);
                                                                                setGrainLoadedValid(true);
                                                                            }}
                                                                            className="inputGroupWithAppend errorLeft text-13-400 secondary-grey"
                                                                            isInvalid={!grainLoadedValid}
                                                                        />
                                                                        <InputGroup.Text className={`inputGroupAppend ${!grainLoadedValid ? "invalidAppend" : ""}`}>
                                                                            t
                                                                        </InputGroup.Text>
                                                                        {!grainLoadedValid ? (
                                                                            <div className="validation-error-tooltip">
                                                                                <Tooltip
                                                                                    anchorSelect={`#grainLoaded`}
                                                                                    place="top"
                                                                                    variant="error"
                                                                                    content="A valid grain loaded is requried."
                                                                                />
                                                                            </div>
                                                                        ) : null}
                                                                    </InputGroup>
                                                                </Form.Group>
                                                        }
                                                    </Col>
                                                    <Col xs={2}>
                                                        {
                                                            !isEditMode ?
                                                                <div className='cc-feed-input p-0'>{roughageLoaded}t</div> :
                                                                <Form.Group>
                                                                    <InputGroup readonlyclasses="text-13-400 secondary-grey">
                                                                        <Form.Control
                                                                            id="roughageLoaded"
                                                                            value={roughageLoaded}
                                                                            onChange={(e) => {
                                                                                e.preventDefault();
                                                                                parseNumericInput(e, FeedNumberValidationRules);
                                                                                setRoughageLoaded(e.target.value);
                                                                                setRoughageLoadedValid(true);
                                                                            }}
                                                                            className="inputGroupWithAppend errorLeft text-13-400 secondary-grey"
                                                                            isInvalid={!roughageLoadedValid}
                                                                        />
                                                                        <InputGroup.Text className={`inputGroupAppend ${!roughageLoadedValid ? "invalidAppend" : ""}`}>
                                                                            t
                                                                        </InputGroup.Text>
                                                                        {!roughageLoadedValid ? (
                                                                            <div className="validation-error-tooltip">
                                                                                <Tooltip
                                                                                    anchorSelect={`#roughageLoaded`}
                                                                                    place="top"
                                                                                    variant="error"
                                                                                    content="A valid roughage loaded is requried."
                                                                                />
                                                                            </div>
                                                                        ) : null}
                                                                    </InputGroup>
                                                                </Form.Group>
                                                        }
                                                    </Col>
                                                </Row> */}
                                                <Row className="bg-grey-transparent py-2">
                                                    <Col xs={6} className="field-label darkblue" style={{ lineHeight: "27px" }}>Total feed onboard</Col>
                                                    <Col xs={2} className="text-end darkblue" style={{ lineHeight: "27px" }}><span className="darkblue" style={{ fontSize: "13px", fontWeight: "400" }}>{formatUpToSpecifiedPrecision(totalPelletsLoaded, 2)}</span><span className="darkblue" style={{ marginLeft: "4px", fontSize: "12px", fontWeight: "500" }}>t</span></Col>
                                                    <Col xs={2} className="text-end darkblue" style={{ lineHeight: "27px" }}><span className="darkblue" style={{ fontSize: "13px", fontWeight: "400" }}>{formatUpToSpecifiedPrecision(totalGrainLoaded, 2)}</span><span className="darkblue" style={{ marginLeft: "4px", fontSize: "12px", fontWeight: "500" }}>t</span></Col>
                                                    <Col xs={2} className="text-end darkblue" style={{ lineHeight: "27px" }}><span className="sdarkblue" style={{ fontSize: "13px", fontWeight: "400" }}>{formatUpToSpecifiedPrecision(totalRoughageLoaded, 2)}</span><span className="darkblue" style={{ marginLeft: "4px", fontSize: "12px", fontWeight: "500" }}>t</span></Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </>
                            : null
                    }
                    {
                        loadError === true && loading === false ?
                            <Row>
                                <Col xs={12}>
                                    <Alert variant='danger'>Unable to load voyage departure and vessel loading report.</Alert>
                                </Col>
                                <Col xs={12}>
                                    <Button
                                        className="me-2 ms-auto"
                                        variant="primary"
                                        onClick={() => {
                                            goBack();
                                        }}
                                        size="lg"
                                        style={{ minWidth: "150px" }}
                                    >
                                        Back
                                    </Button>
                                </Col>
                            </Row>
                            : null
                    }
                </Container>
                {loading === false && hasData === true ? (
                    <Row className="mt-5 mx-0" style={{ position: "relative", top: "-300px" }}>
                        {saveSuccess === true ? (
                            <Col xs={12}>
                                <Container>
                                    <Row>
                                        <Col xs={12}>
                                            <Alert variant="success">Departure report updated successfully.</Alert>
                                        </Col>
                                    </Row>
                                </Container>
                            </Col>
                        ) : null}

                        {saveError === true ? (
                            <Col xs={12}>
                                <Container>
                                    <Row>
                                        <Col xs={12}>
                                            <Alert variant="danger">{saveErrorMessage}</Alert>
                                        </Col>
                                    </Row>
                                </Container>
                            </Col>
                        ) : null}

                        {isEditMode === true ? (
                            <Col xs={12}>
                                <Stack direction="horizontal" gap={2} style={{ justifyContent: "center" }}>
                                    <Button
                                        variant="secondary"
                                        onClick={() => {
                                            cancelEdit();
                                        }}
                                        size="lg"
                                        style={{ minWidth: "150px" }}
                                    >
                                        Cancel
                                    </Button>
                                    <ReadWriteButton
                                        writeonly={true}
                                        variant="primary"
                                        onClick={(e) => {
                                            validateAndShowEditModal(e);
                                        }}
                                        size="lg"
                                        style={{ minWidth: "150px" }}
                                    >
                                        Update
                                    </ReadWriteButton>
                                </Stack>
                            </Col>
                        ) : (
                            <Col xs={12}>
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <Button
                                        variant="primary"
                                        onClick={() => {
                                            goBack();
                                        }}
                                        size="lg"
                                        style={{ minWidth: "150px" }}
                                    >
                                        Done
                                    </Button>
                                </div>
                            </Col>
                        )}
                    </Row>
                ) : null}
            </Container>

            <EditLogModal
                title="Edit Departure Report"
                page="Departure Report"
                userID={userCtx.user.id}
                consignmentIDs={[consignmentID]}
                showModal={editModalShow}
                reasonOptions={editPageReasons}
                onClose={onEditModalClosed}
                onSaveSuccess={onEditModalSaveSuccess}
                onSaveFail={onEditModalSaveFailed}
            />
        </LoggedInContainer>
    );
};

export default Voyage_Departure_And_Vessel_Loading;